import { isEqual } from "lodash"
import { EEGMontage, MontageType } from "../Types/EEG"

/**
 * The montage an EEG or SD Detection window shows. Saved window props reach the window atom only when the
 * D3 controller first mounts, and it mounts only for a montage with resolvable channels,
 * so until then the saved montage stands in for an unset atom montage.
 */
export function getWindowMontage(hasInitialized: boolean, atomMontage: EEGMontage | null, savedMontage: EEGMontage | null | undefined): EEGMontage | null {
	if (hasInitialized) {
		return atomMontage
	}

	return atomMontage ?? savedMontage ?? null
}

/**
 * Returns the montage that should replace `montage`, or undefined to keep it.
 * A montage that no longer exists falls back to the default, then the first standard
 * montage, then any montage, then null. An existing montage is refreshed from the list.
 */
export function getValidatedMontage(montage: EEGMontage | null, eegMontages: EEGMontage[], defaultMontageId: number): EEGMontage | null | undefined {
	const foundMontage = eegMontages.find(m => m.id === montage?.id)

	let newMontage: EEGMontage | null | undefined = undefined

	if (!foundMontage) {
		const standardMontages = eegMontages.filter(m => m.type === MontageType.STANDARD)
		const defaultMontage = eegMontages.find(m => m.id === defaultMontageId)

		if (defaultMontage) {
			newMontage = defaultMontage
		} else if (standardMontages.length > 0) {
			newMontage = standardMontages[0]
		} else if (eegMontages.length > 0) {
			newMontage = eegMontages[0]
		} else {
			newMontage = null
		}
	} else if (!isEqual(foundMontage, montage)) {
		newMontage = foundMontage
	}

	if (newMontage !== undefined && !isEqual(montage, newMontage)) { // null is not the same thing as undefined
		return newMontage
	}

	return undefined
}
